<template>
  <div class="suppliers">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <SuppliersTable @create-supplier="onCreateSupplier" @edit-supplier="onEditSupplier" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import SuppliersTable from '@/components/Suppliers/SuppliersTable';

export default {
  name: 'Suppliers',
  components: {
    Breadcrumbs,
    SuppliersTable,
  },
  computed: {
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('all_suppliers') }];
    },
  },
  methods: {
    onCreateSupplier() {
      this.$router.push({ name: 'SupplierCreatePage' });
    },
    onEditSupplier(supplier) {
      this.$router.push({
        name: 'SupplierEditPage',
        params: { supplierNumber: supplier.number },
      });
    },
  },
};
</script>

<style lang="scss"></style>
